module.exports = __webpack_public_path__ + "static/media/architecture.4d1fd487.jpg";